// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tag{height:28px;line-height:28px!important;padding:0 8px;margin-right:8px}.button-new-tag{margin-bottom:5px}.input-new-tag{width:56px}.input-new-tag .el-input__inner{padding:0 6px!important;height:28px}", ""]);
// Exports
module.exports = exports;
